import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker'

import {
  Grid, Accordion, AccordionSummary, AccordionDetails,
  Typography, Card, CardContent, Dialog, DialogContent, DialogTitle,
  Chip, List, Avatar, IconButton, Paper, Button, Toolbar, AppBar, DialogContentText, DialogActions, TextField,
  ListItem, ListItemAvatar, ListItemText, Tooltip, Divider
} from '@material-ui/core'

import {
  History as HistoryIcon, Flag as FlagIcon, FolderShared, CloseRounded, Announcement as AnnouncementIcon
} from '@material-ui/icons'

import QueryString from 'query-string'
import moment from 'moment'

import {
  getSeverityClass, toggleImage, formatStatusClass, captureUrlStatuses
} from '../../../utils'

import {
  getComments, getViolationTerms,
  getHistory, postHistory, setFromLink, requestDestination
} from '../../../redux/actions'

import { setViolations } from '../../../redux/actions/violations'

import {
  setStatusSnack, setTriggerFilter, setAwaitTrigger, setFilter, setEndOfLink
} from '../../../redux/actions/select'

import {
  ConfirmToast, MenuButton, NotificationToast,
  CommentAccordion, DetailsSidebar, StatusSnack,
  QuarantineSubBanner
  // DetailsAccordion
} from '../tools'

import { SET_TEMPORARY_QUARANTINE_VIEW } from '../../../redux/types'

const onPrem = Boolean(process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true')

const REQUEST_ERRORS = {
  DOMAIN_EXISTS: 'DOMAIN_EXISTS',
  DOMAIN_RESTRCITED: 'DOMAIN_RESTRICTED'
}

const SingleView = (props) => {
  const {
    capture, Captures, useStyles, onQuickFilter
  } = props

  const dispatch = useCallback(useDispatch(), [])
  const classes = useStyles()

  const parsedProps = QueryString.parse(props.location.search)
  const currentCapture = parseInt(parsedProps.capture, 10)

  /* <========= Start Selectors =========> */
  const {
    comments, history, hasHistory, actions, violationTerms,
    violations: { hits } = {}
  } = useSelector(state => state.violations)
  const {
    supervisorID: currentSupervisor, permissions: userPermissions, defaultView
  } = useSelector(state => state.auth)
  const { TriggerFilter, SnackShow, EndOfLink, NeedFilter, Filter } = useSelector(state => state.selection)
  const {
    unitDestinations = {}, ciscoUmbrellaSettings: ciscoSettings, restrictedDomains, blockRequests: userBlockRequests
  } = useSelector(state => state.integrations)
  const { userRoleSupervisors } = useSelector(state => state.userListings)

  const [accordionExpanded, setAccordionExpanded] = useState('details')
  const [requestSite, setRequestSite] = useState('')
  const [requestComment, setRequestComment] = useState('')

  const [violationComments, setViolationComments] = useState([])
  const [violationHistory, setViolationHistory] = useState([])
  const [violationAdditionalTerms, setViolationAdditionalTerms] = useState([])
  const [allSupervisors, setAllSupervisors] = useState([])
  const [captureDestinations, setCaptureDestinations] = useState([])
  const [domainsRestricted, setDomainsRestricted] = useState([])
  const [blockRequests, setBlockRequests] = useState({})
  const [captureUrlStatus, setCaptureUrlStatus] = useState(null)

  const [supervisor, setSupervisor] = useState({
    firstName: '',
    lastName: '',
    avatarPath: null
  })

  const [currentView, setCurrentView] = useState(currentCapture)
  const [canRequestBlock, setCanRequestBlock] = useState(false)
  const [isDomainBlocked, setIsDomainBlocked] = useState(false)
  const [openRequest, setOpenRequest] = useState(false)
  const [canViewImage, setCanViewImage] = useState(false)
  const [tempView, setTempView] = useState(false)
  const [fullViewOpen, setFullViewOpen] = useState(false)

  useEffect(() => {
    if (userPermissions && Array.isArray(userPermissions)) {
      // filter through permissions to determine whether the user can view quarantined images
      const viewPermission = userPermissions && userPermissions.length ? userPermissions.includes('violation-quarantine-viewer') : false
      // if the array contains the permission, give them rights. Otherwise, set to false
      if (viewPermission) {
        setCanViewImage(true)
      } else {
        setCanViewImage(false)
      }
    }
  }, [userPermissions])

  useEffect(() => {
    if (currentView !== currentCapture) {
      setCurrentView(currentCapture)
      if (tempView) {
        setTempView(false)
        dispatch({
          type: SET_TEMPORARY_QUARANTINE_VIEW,
          payload: false
        })
      }
    }
  }, [currentCapture, currentView, tempView, dispatch])

  useEffect(() => {
    return () => {
      dispatch({ type: SET_TEMPORARY_QUARANTINE_VIEW, payload: false })
    }
  }, [dispatch])

  // Determine if capture has destinations
  useMemo(() => {
    if (unitDestinations && capture.units && Array.isArray(capture.units)) {
      const [{ unitID: captureUnitID } = {}] = capture.units.slice(-1)

      if (captureUnitID && unitDestinations[captureUnitID] && Array.isArray(unitDestinations[captureUnitID])) {
        setCaptureDestinations(unitDestinations[captureUnitID])
      } else {
        setCaptureDestinations([])
      }
    }
  }, [unitDestinations, capture.units])

  useMemo(() => {
    if (restrictedDomains && Array.isArray(restrictedDomains)) { setDomainsRestricted(restrictedDomains) }
  }, [restrictedDomains])

  useMemo(() => {
    if (typeof userBlockRequests === 'object' && Array.isArray(userBlockRequests.approved)) { setBlockRequests(userBlockRequests) }
  }, [userBlockRequests])

  // checking if current capture's URL has already been processed
  useMemo(() => {
    if (Array.isArray(blockRequests.approved) && Boolean(capture.violationID)) {
      setCaptureUrlStatus(null)

      if (typeof capture.websiteUrl === 'string' && Boolean(capture.websiteUrl.length)) {
        const isApproved = Boolean(blockRequests.approved.find(x => typeof x === 'object' && Boolean(x.domain) && capture.websiteUrl.includes(x.domain)))
        const isDenied = Boolean(blockRequests.denied.find(x => typeof x === 'object' && Boolean(x.domain) && capture.websiteUrl.includes(x.domain)))
        const isPending = Boolean(blockRequests.pending.find(x => typeof x === 'object' && Boolean(x.domain) && capture.websiteUrl.includes(x.domain)))

        if (isApproved) {
          setCaptureUrlStatus(captureUrlStatuses.APPROVED)
        } else if (isDenied) {
          setCaptureUrlStatus(captureUrlStatuses.DENIED)
        } else if (isPending) {
          setCaptureUrlStatus(captureUrlStatuses.PENDING)
        }
      }
    }
  }, [blockRequests, capture.websiteUrl, capture.violationID])

  useMemo(() => {
    if (Array.isArray(userPermissions) && typeof ciscoSettings === 'object' && Array.isArray(capture.units)) {
      const [{ unitID: captureUnitID } = {}] = capture.units.slice(-1)

      if (
        typeof ciscoSettings.summary === 'object' && Boolean(ciscoSettings.summary.enabled) && typeof ciscoSettings.units === 'object' &&
        typeof ciscoSettings.units[captureUnitID] === 'object' && Boolean(ciscoSettings.units[captureUnitID].unitID)
      ) {
        setCanRequestBlock(Boolean(userPermissions.find((permission) => permission === 'cisco-request-block')))
      } else {
        setCanRequestBlock(false)
      }
    }
  }, [userPermissions, ciscoSettings, capture.units])

  useMemo(() => {
    if (captureDestinations && canRequestBlock && capture.websiteUrl && blockRequests && domainsRestricted) {
      const blockedDestinations = captureDestinations.concat(domainsRestricted).concat(blockRequests.approved, blockRequests.denied, blockRequests.pending)

      const isCaptureBlocked = Boolean(
        blockedDestinations.find((destinationInfo) => {
          if (destinationInfo && (destinationInfo.destination || destinationInfo.domain)) {
            let destinationDomain = ''
            let captureDomain = ''
            let captureUrl = ''

            if (!capture.websiteUrl.startsWith('http')) {
              captureUrl = 'https://' + capture.websiteUrl
            } else {
              captureUrl = capture.websiteUrl
            }

            try {
              const { hostname: destinationHostname = '' } = new URL(destinationInfo.destination || destinationInfo.domain)
              destinationDomain = destinationHostname.replace('www.', '')
            } catch (err) {
              destinationDomain = (destinationInfo.destination || destinationInfo.domain).replace('www.', '')
            }

            try {
              const { hostname: captureHostname = '' } = new URL(captureUrl)
              captureDomain = captureHostname.replace('www.', '')
            } catch (err) {
              captureDomain = capture.websiteUrl.replace('www.', '')
            }

            return captureDomain.includes(destinationDomain)
          }

          return false
        })
      )

      setIsDomainBlocked(isCaptureBlocked)
    }
  }, [captureDestinations, canRequestBlock, capture.websiteUrl, blockRequests, domainsRestricted])

  // get comments, hitsory, terms for the new violation
  useMemo(() => {
    dispatch(getComments([capture.violationID]))
    dispatch(getHistory([capture.violationID]))
    dispatch(getViolationTerms(capture.violationID))
  }, [capture.violationID, dispatch])

  // set additional capture terms for the violation, if they exist
  useMemo(() => {
    if (violationTerms) {
      setViolationAdditionalTerms(violationTerms)
    }
  }, [violationTerms])

  // populate supervisor list
  useMemo(() => {
    if (userRoleSupervisors.length !== 0) {
      const mappedSupervisors = []
      userRoleSupervisors.forEach((supervisor) => {
        mappedSupervisors.push(...supervisor.roleSupervisors)
      })

      setAllSupervisors(mappedSupervisors)

      const targetSupervisor = mappedSupervisors.find((supervisor) => {
        return supervisor.supervisorID === currentSupervisor
      })

      if (targetSupervisor) {
        setSupervisor(targetSupervisor)
      }
    }
  }, [userRoleSupervisors, currentSupervisor])

  // populate the comment array for the violation
  useEffect(() => {
    if (comments && allSupervisors.length !== 0) {
      const mappedComments = comments.map((comment) => {
        const commentSupervisor = allSupervisors.find((supervisor) => {
          return comment.supervisorID === supervisor.supervisorID
        })

        return {
          ...comment,
          ...commentSupervisor
        }
      })
      setViolationComments(mappedComments)
    }
  }, [comments, allSupervisors])

  // populate the history array for the violation
  useEffect(() => {
    console.log('Populate history')
    if (history !== undefined && allSupervisors.length !== 0 && actions.length !== 0) {
      const mappedHistory = history.map((historyItem) => {
        const historySupervisor = allSupervisors.find((supervisor) => {
          return historyItem.supervisorID === supervisor.supervisorID
        })

        const historyAction = actions.find((action) => {
          return historyItem.actionID === action.actionID
        })

        const actualHistoryAction = `${historyAction.details.toLowerCase()}`
        return {
          historyAction: actualHistoryAction,
          ...historyItem,
          ...historySupervisor,
          ...historyAction
        }
      })

      setViolationHistory(mappedHistory)
    }
  }, [history, actions, allSupervisors])

  // add a view record if we have not already
  useEffect(() => {
    if (hasHistory && history != null && actions.length !== 0 && currentSupervisor !== '' && capture.violationID !== '') {
      const addHistoryUser = (action) => {
        dispatch(postHistory([capture.violationID], action, 'VIEWED', fireAddSuccess, fireAddFailure))
      }

      const fireAddSuccess = () => {
        dispatch(getHistory([capture.violationID]))
      }

      const fireAddFailure = () => { }

      const viewedAction = actions.find((action) => action.details === 'VIEWED')
      const viewedHistory = history.filter((historyItem) => historyItem.actionID === viewedAction.actionID)

      if (viewedHistory) {
        const hasViewed = viewedHistory.find((historyItem) => historyItem.supervisorID === currentSupervisor)
        if (hasViewed === undefined) {
          addHistoryUser(viewedAction.actionID)
        }
      }
    }
  }, [hasHistory, history, actions, currentSupervisor, capture.violationID, dispatch])

  const [holdFilter, setHoldFilter] = useState(null)
  const handleQuickFilter = (map) => {
    if (formatStatusClass(capture.statusFlag, 'text') === 'New') {
      dispatch(setStatusSnack(true))
      dispatch(setAwaitTrigger(true))
      setHoldFilter(map)
    } else {
      dispatch(setStatusSnack(false))
      dispatch(setAwaitTrigger(false))
      onQuickFilter(map, dispatch, Filter)
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
      setHoldFilter(null)
    }
  }

  const handleClearFilter = () => {
    dispatch(setEndOfLink(false))
    dispatch(setFilter({
      ...Filter,
      violationIDs: [],
      fastFilterID: '',
      includeViolationIDs: [],
      refresh: true
    }))
    if (defaultView === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (defaultView === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
    dispatch(setFromLink(false))
  }

  useEffect(() => {
    if (TriggerFilter) {
      onQuickFilter(holdFilter, dispatch, Filter)
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
      setHoldFilter(null)
      dispatch(setTriggerFilter(false))
      dispatch(setAwaitTrigger(false))
    }
  }, [TriggerFilter, dispatch, holdFilter, onQuickFilter, props.history, Filter])

  const toggleFullQuarantine = async () => {
    if (capture.quarantined === false) {
      const changeStat = await ConfirmToast({ msg: 'Warning: This action blocks the image from being viewed by anyone except for supervisors with the proper elevated permissions.', txt: 'Are you sure you want to quarantine this violation?' })

      if (changeStat === true) {
        const addQuarantine = actions.find((action) => action.details === 'QUARANTINED')
        dispatch(postHistory([capture.violationID], addQuarantine.actionID, addQuarantine.details, fireQuarantineSuccess, fireQuarantineFailure))

        // const updateStatus = await new Promise((resolve, reject) => {
        //   dispatch(setViolationStatus([capture.violationID], 'P', resolve, reject))
        // })

        // if (updateStatus) { return true } else { return false }
      }
    } else {
      const removeQuarantine = actions.find((action) => action.details === 'UN-QUARANTINED')
      dispatch(postHistory([capture.violationID], removeQuarantine.actionID, removeQuarantine.details, fireQuarantineSuccess, fireQuarantineFailure))
    }
  }

  const fireQuarantineSuccess = async (partial = false, newUrl = '') => {
    // this function is passed in as the success func for both full and partial quarantine.
    // BUT the redux action used for full quarantine is used in many places and already passes in an argument. However, as that argument is not needed here, we shall simply reassign it to false if it comes in as anything but true.
    if (partial && partial !== true) { partial = false }
    NotificationToast(false, `Capture has been quarantined!${partial ? ' Your changes will display shortly.' : ''}`)

    dispatch(getHistory([capture.violationID]))
    // window.location.reload()
    const tempCaptures = [...Captures]
    const quarantinedCapture = tempCaptures.find((tempCapture) => tempCapture.violationID === capture.violationID)
    quarantinedCapture.quarantined = true

    // if we were partially quarantining the image, set the local redux state to the new redacted value and reassign the signed url
    if (partial) {
      if (onPrem) {
        if (newUrl) { newUrl = `https://${window.location.hostname}/${newUrl}` }
        const violationImg = document.getElementById(`img-${capture.violationID}`)
        const fetchUrl = newUrl || capture.signedUrl
        if (violationImg) { violationImg.src = `${fetchUrl}?t=${moment().unix()}` }
      }
      quarantinedCapture.redacted = true
      quarantinedCapture.signedUrl = newUrl || capture.signedUrl // default back to the original url if none was returned from redux call
      // in order to be sure the image has time to update, delay setting the local list
      const delay = (time) => new Promise((resolve, reject) => setTimeout(resolve, time))
      await trackPromise(delay(5000))
    }

    dispatch(setViolations(tempCaptures))
  }

  const fireQuarantineFailure = () => {
    NotificationToast(true, 'Failed to update quarantine!')
  }

  const getStatusClass = (status) => {
    switch (status) {
      case 'U': return classes.newStatus
      case 'P': return classes.problemStatus
      case 'N': return classes.noProblemStatus
      case 'H': return classes.holdStatus
      case 'S': return classes.solvedStatus
      case 'C': return classes.changedStatus
      default: return null
    }
  }

  const getAvatarBackground = (severity) => {
    switch (getSeverityClass(severity)) {
      case 'mild': return classes.mild
      case 'bad': return classes.bad
      case 'okay': return classes.okay
      case 'notGreat': return classes.notGreat
      case 'warn': return classes.warn
      default: return null
    }
  }

  const handleAccordionChange = (panel) => (e, isExpanded) => {
    setAccordionExpanded(isExpanded ? panel : false)
  }

  const toggleTempView = () => {
    if (tempView === false) {
      setTempView(true)
      dispatch({
        type: SET_TEMPORARY_QUARANTINE_VIEW,
        payload: true
      })
      const addView = actions.find((action) => action.details === 'VIEWED QUARANTINED')
      dispatch(postHistory([capture.violationID], addView.actionID, addView.details, fireViewSuccess, fireViewFailure))
    } else if (tempView === true) {
      setTempView(false)
      dispatch({
        type: SET_TEMPORARY_QUARANTINE_VIEW,
        payload: false
      })
    }
  }

  const fireViewSuccess = () => {
    NotificationToast(false, `Viewing Capture ${capture.violationID}`)
    dispatch(getHistory([capture.violationID]))
  }

  const fireViewFailure = () => {
    NotificationToast(true, 'Failed to View Capture')
  }

  const handleDialogOpen = (capture) => {
    if (!capture.quarantined || (canViewImage && tempView)) {
      setFullViewOpen(true)
    }
  }

  const NeedFilterView = () => {
    return (
      <Grid
        container
        direction='row'
        justify='center'
        className='w-100 mx-auto'
        style={{
          height: '15em',
          maxWidth: '40em',
          marginTop: '4em'
        }}
        key='no-return-message-grid'
      >
        <Paper
          className='w-100 mx-auto'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          classes={{ root: classes.paperRoot }}
          elevation={3}
        >
          <Grid container item direction='column' justify='center' alignContent='center'>
            <Grid container item justify='center' alignContent='center'>
              <AnnouncementIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />
            </Grid>
            <Grid container direction='column' item justify='center' alignContent='center'>
              <Typography
                variant='h5'
                color='primary'
                classes={{ colorPrimary: classes.whiteText }}
                style={{ fontWeight: 'bold', textAlign: 'center' }}
                className='mt-2'
              >
                {currentCapture > hits ? 'Heads up!' : 'The End'}
              </Typography>
              <Typography
                variant='h6'
                color='primary'
                classes={{ colorPrimary: classes.whiteText }}
                style={{ textAlign: 'center' }}
                className='mt-2'
              >
                {currentCapture > hits || hits === 0 ? 'You have reached the maximum number of displayed captures.' : 'There are no further captures using this filter.'}
              </Typography>
              {currentCapture > hits &&
                <Typography
                  variant='body1'
                  color='primary'
                  classes={{ colorPrimary: classes.whiteText }}
                  style={{ textAlign: 'center' }}
                  className='mt-1'
                >
                  Please use a filter to refine your results.
                </Typography>}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }

  const handleBlockRequest = () => {
    if (canRequestBlock && !isDomainBlocked && capture.units) {
      let captureUrl = ''

      if (!capture.websiteUrl.startsWith('http')) {
        captureUrl = 'https://' + capture.websiteUrl
      } else {
        captureUrl = capture.websiteUrl
      }

      const [{ unitID: captureUnitID } = {}] = capture.units.slice(-1)
      const requestInfo = { unitID: captureUnitID, destination: captureUrl, comment: requestComment }

      if (captureUnitID) {
        dispatch(requestDestination(requestInfo, fireRequestSuccess, fireRequestFailure))
      } else {
        NotificationToast(true, 'Failed to find unit associated with capture!')
      }
    } else {
      // More than likely never gonna happen
      NotificationToast(true, 'You do not have permissions to perform this action')
    }
  }

  const onRequestBlock = () => {
    let captureDomain = ''
    let captureUrl = ''

    if (!capture.websiteUrl.startsWith('http')) {
      captureUrl = 'https://' + capture.websiteUrl
    } else {
      captureUrl = capture.websiteUrl
    }

    try {
      const { hostname: captureHostname = '' } = new URL(captureUrl)
      captureDomain = captureHostname
    } catch (err) {
      captureDomain = captureUrl
    }

    setRequestSite(captureDomain); setOpenRequest(true)
  }

  const handleCancelRequest = () => { setOpenRequest(false); setRequestComment(''); setRequestSite('') }

  const fireRequestSuccess = () => {
    NotificationToast(false, 'Website has been requested for block! Integrations supervisor will review request.')
    setCaptureUrlStatus(captureUrlStatuses.PENDING)
    handleCancelRequest()
  }
  const fireRequestFailure = (apiCode) => {
    switch (apiCode) {
      case REQUEST_ERRORS.DOMAIN_RESTRCITED: {
        NotificationToast(true, 'Failed to request domain, domain is restricted by LearnSafe.')
        setIsDomainBlocked(true)
        handleCancelRequest()
        break
      }
      case REQUEST_ERRORS.DOMAIN_EXISTS: {
        NotificationToast(true, 'Failed to request domain, domain has been requested already or has been approved.')
        setIsDomainBlocked(true)
        handleCancelRequest()
        break
      }
      default: NotificationToast(true, 'Failed to request website.')
    }
  }

  return (
    <>
      {NeedFilter &&
        <NeedFilterView />}
      {!NeedFilter &&
        <Grid container direction='row' justify='center' style={{ paddingLeft: '2em' }} spacing={5}>

          {/* Image area start */}
          <Grid container item xs={8} md={9} lg={10}>
            {EndOfLink
              ? (
                <Grid
                  container
                  direction='row'
                  justify='center'
                  className='w-100 mx-auto'
                  style={{
                    height: '15em',
                    maxWidth: '40em',
                    marginTop: '4em'
                  }}
                >
                  <Paper
                    className='w-100 mx-auto'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    classes={{ root: classes.paperRoot }}
                    elevation={3}
                  >
                    <Grid container item direction='column' justify='center' alignContent='center'>
                      <Grid container item justify='center' alignContent='center'>
                        <FolderShared style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />
                      </Grid>
                      <Grid container direction='column' item justify='center' alignItems='center'>
                        <Typography
                          variant='h5'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          style={{ fontWeight: 'bold' }}
                          className='mt-2 mx-auto'
                        >
                          Hey there!
                        </Typography>
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          style={{ textAlign: 'center', fontWeight: 'bold' }}
                          className='mt-2'
                        >
                          Looks like you have reached the end of the shared captures.
                        </Typography>
                        <Typography
                          variant='body1'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          style={{ textAlign: 'center', maxWidth: '30em' }}
                          className='mt-2'
                        >
                          You can use the back arrow to return to the last capture or click below to return to your default view.
                        </Typography>
                        <Button
                          variant='contained'
                          size='small'
                          className='my-2'
                          style={{ textTransform: 'none', backgroundColor: '#007BFF', color: '#FFFFFF' }}
                          onClick={handleClearFilter}
                        >
                          Exit Shared Captures
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>)
              : (
                <Card className={`${getStatusClass(capture.statusFlag)} w-100 ml-3`} data-violationkey={capture.violationID} id='detail-capture'>
                  <Grid item container direction='row'>

                    {/* Image Column */}
                    <Grid
                      item
                      xs={12}
                      container
                      direction='row'
                      style={{ cursor: (capture.quarantined && tempView === false) ? 'default' : 'pointer' }}
                      className={`mx-auto h-100 w-100 ${classes.imageContainer}`}
                      onClick={() => { handleDialogOpen(capture) }}
                    >
                      {toggleImage(capture, tempView, null, { width: '100%', height: '100%', margin: 'auto' })}
                      {capture.quarantined && !tempView && <QuarantineSubBanner redacted={capture.redacted} />}
                    </Grid>
                    {capture && capture.isFlagged
                      ? (
                        <Grid container direction='row' className={classes.flagContainer}>
                          <Avatar variant='rounded' className={classes.flagAvatar}>
                            <FlagIcon />
                          </Avatar>
                        </Grid>)
                      : (<></>)}
                  </Grid>

                  {/* Comments & History Start */}
                  <CardContent>
                    <Grid container direction='row'>
                      <Grid item container direction='column' spacing={2} className='w-100 mx-auto my-auto'>
                        {/* Comments */}
                        <CommentAccordion
                          classes={classes}
                          capture={capture}
                          supervisor={supervisor}
                          accordionExpanded={accordionExpanded}
                          handleAccordionChange={handleAccordionChange}
                          violationComments={violationComments}
                          setViolationComments={setViolationComments}
                          currentView={currentView}
                          currentCapture={currentCapture}
                        />

                        {/* History */}
                        <Grid container item direction='row'>
                          <Grid item xs={12}>
                            <Accordion
                              expanded={accordionExpanded === 'history'}
                              onChange={handleAccordionChange('history')}
                              className={`w-100 ${classes.contentAccordion}`}
                            >
                              <AccordionSummary
                                expandIcon={<MenuButton margin='auto' open={accordionExpanded === 'history'} />}
                              >
                                <Grid container direction='row' item xs={10} spacing={2} className='w-100' justify='flex-start' alignItems='center'>
                                  <Grid item className='ml-4'>
                                    <Typography variant='h6' className='font-weight-bold text-primary'><HistoryIcon fontSize='large' /> HISTORY</Typography>
                                  </Grid>
                                  <Grid item>
                                    <Chip label={violationHistory.length} className={classes.singleChip} />
                                  </Grid>
                                </Grid>
                              </AccordionSummary>

                              <AccordionDetails className={classes.accordionDetails}>
                                <Grid container item direction='column' justify='center'>
                                  <List dense className={classes.contentList}>
                                    {
                                      violationHistory.reduce((arr, history) => {
                                        if (typeof history === 'object' && Boolean(history) && Boolean(history.historyID)) {
                                          const tooltipTitle = typeof history === 'object' && Boolean(history) && Boolean(history.firstName) && Boolean(history.lastName)
                                            ? `${history.firstName} ${history.lastName}`
                                            : 'LearnSafe'

                                          arr.push(
                                            <React.Fragment key={`action-${history.historyID}-${history.timestamp}`}>
                                              <ListItem>
                                                <ListItemAvatar>
                                                  <Tooltip
                                                    title={tooltipTitle}
                                                    placement='top'
                                                  >
                                                    <Avatar className={classes.commentAvatar} src={history.avatarPath || ''}>
                                                      {tooltipTitle !== 'LearnSafe' ? `${history.firstName.substring(0, 1)}${history.lastName.substring(0, 1)}` : 'LS'}
                                                    </Avatar>
                                                  </Tooltip>
                                                </ListItemAvatar>

                                                <ListItemText
                                                  className='text-dark'
                                                  disableTypography
                                                  primary={
                                                    <Grid container>
                                                      <Grid item xs={9} container direction='row'>
                                                        <Typography variant='body1' className='font-weight-bold text-wrap w-100'>{tooltipTitle}</Typography>
                                                      </Grid>
                                                    </Grid>
                                                  }
                                                  secondary={
                                                    <Typography component='span' variant='body2' className='text-wrap w-100'>
                                                      {
                                                        history.historyAction === 'ignored'
                                                          ? (
                                                            <>
                                                              <span className='text-capitalize'>The phrase detected here was configured by a LearnSafe Supervisor to be automatically labeled with the status of Not A Problem.</span>
                                                            </>)
                                                          : (
                                                            <>
                                                              <span className='text-capitalize'>{history.historyAction}</span> on
                                                              <span className='text-primary font-italic'> {moment.unix(history.timestamp).format('MMMM Do YYYY, h:mma')}</span>
                                                            </>)
                                                      }
                                                    </Typography>
                                                  }
                                                />
                                              </ListItem>
                                              <Divider variant='inset' component='li' />
                                            </React.Fragment>
                                          )
                                        }
                                        return arr
                                      }, [])
                                    }
                                  </List>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>
                  </CardContent>
                  {/* Comments & History End */}
                </Card>)}
          </Grid>

          {/* Details Column */}
          <Grid container item direction='row' className={`w-100 mx-auto p-2 mt-3 mb-3 ${classes.detailsContainer}`} xs={4} md={3} lg={2}>
            <DetailsSidebar
              classes={classes}
              capture={capture}
              violationAdditionalTerms={violationAdditionalTerms}
              canViewImage={canViewImage}
              canRequestBlock={canRequestBlock}
              isDomainBlocked={isDomainBlocked}
              tempView={tempView}
              captureUrlStatus={captureUrlStatus}
              onRequestBlock={onRequestBlock}
              toggleTempView={toggleTempView}
              handleQuickFilter={handleQuickFilter}
              toggleFullQuarantine={toggleFullQuarantine}
              getAvatarBackground={getAvatarBackground}
              fireQuarantineSuccess={fireQuarantineSuccess}
            />
          </Grid>
          {/* Image area end */}

          {/* Request block dialog */}
          <Dialog
            open={openRequest}
            onClose={handleCancelRequest}
          >
            <DialogTitle>Request Block</DialogTitle>

            <DialogContent>
              <DialogContentText>
                Do you want to block <Typography variant='button' className='font-weight-bold'>{requestSite}</Typography>?
              </DialogContentText>
              <TextField
                label='Reason For Blocking'
                autoFocus
                fullWidth
                margin='dense'
                value={requestComment}
                onChange={(e) => setRequestComment(e.target.value)}
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCancelRequest}>Cancel</Button>
              <Button onClick={handleBlockRequest}>Block</Button>
            </DialogActions>
          </Dialog>

          {/* Full Screen Image */}
          <Dialog
            fullScreen
            open={fullViewOpen}
            onClose={() => setFullViewOpen(false)}
          >
            <AppBar
              style={{
                position: 'relative',
                backgroundColor: '#313538'
              }}
            >
              <Toolbar>
                <Grid container direction='row'>
                  <Grid item xs={9}>
                    <Typography variant='h6' style={{ color: 'white' }}>{`Viewing Capture: ${capture.violationID} `}</Typography>
                  </Grid>
                  <Grid container justify='flex-end' item xs={3}>
                    <IconButton onClick={() => setFullViewOpen(false)}>
                      <CloseRounded style={{ color: 'white' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
            <DialogContent
              style={{ backgroundColor: '#666666' }}
              onClick={() => setFullViewOpen(false)}
            >
              <Grid container justify='center' alignContent='center'>
                {toggleImage(capture, Boolean(canViewImage && tempView), null, { boxShadow: '-1px 7px 11px 2px rgba(0,0,0,0.77)', width: '100%' })}
              </Grid>
            </DialogContent>
          </Dialog>

        </Grid>}

      <StatusSnack snackOpen={SnackShow} onClose={() => dispatch(setStatusSnack(false))} />
    </>
  )
}

export default withRouter(SingleView)
